import React, { useCallback, useEffect, useRef, useState } from 'react';

import Loading from '../../../General/Loading';
import Table from '../Table';

import InterestUri from '../../../../Enum/InterestUri';
import { HookInterface } from '../../../../Interface/News/NewsInterface';

import useIsFilterLoading from '../../../../Hook/Interest/UseIsFilterLoading';
import useGetFilteredValues from '../../../../Hook/Interest/UseGetFilteredValues';

interface Props {
    useHook: HookInterface;
    section: InterestUri;
}

interface State {
    page: number;
}

const INITIAL_STATE: State = {
    page: 1,
};

const AMOUNT_PER_PAGE = 25;

const NewsTable: React.FC<Props> = ({ useHook, section }) => {
    const isFilterLoading = useIsFilterLoading();
    const { newsLabels, dateFrom, dateTo } = useGetFilteredValues();
    const [state, setState] = useState(INITIAL_STATE);
    const { error, data, headers, loading, pageLoading, total } = useHook(newsLabels, dateFrom, dateTo, state.page);
    const loaderRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        if (isFilterLoading) {
            setState(INITIAL_STATE);
        }
    }, [isFilterLoading]);

    const onScroll = useCallback((): void => {
        if (pageLoading || loaderRef.current === null || total < state.page * AMOUNT_PER_PAGE) {
            return;
        }

        const { scrollTop, scrollHeight, clientHeight } = loaderRef.current;

        if (!pageLoading && scrollHeight - scrollTop <= clientHeight) {
            setState(prev => ({ ...prev, page: prev.page + 1 }));
        }
    }, [pageLoading, total, state.page]);

    if (isFilterLoading || loading) {
        return <Loading />;
    }

    if (error || !data.length) {
        return <p className="no-results">Er zijn geen producten gevonden met de gekozen filters.</p>;
    }

    return (
        <div className="lazyload-table-wrapper" ref={loaderRef} onScroll={onScroll}>
            <Table className="news-table colored-table" data={data} headers={headers} section={section} />
        </div>
    );
}

export default NewsTable;
